// (c) Copyright Mimic Networks, Inc. 2024
//
import React, { Fragment } from 'react'
import clsx from 'clsx'
import {
  Cog6ToothIcon,
  GlobeAltIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline'

const Menu = () => {
  const menuItemBaseStyle = 'px-3 py-2 rounded-sm'
  const iconStyle = 'w-4 h-4'
  const items = [
    {
      name: 'Available Nodes',
      link: '/',
      icon: GlobeAltIcon,
    },
  ]

  const Item = ({ item, className }) => {
    return (
      <a
        key={item.link}
        href={item.link}
        className={clsx(
          document.location.pathname === item.link && 'bg-mimic-light-brown',
          menuItemBaseStyle,
          className,
          'flex items-center space-x-2',
          'hover:bg-gray-200'
        )}
      >
        {item.icon && <item.icon className={iconStyle} />}
        <span>{item.name}</span>
      </a>
    )
  }

  return (
    <div className="flex flex-col py-6 px-1 text-sm font-sans space-y-1">
      {items.map((item) => (
        <Fragment key={item.name}>
          {item.options ? (
            <>
              <hr />
              <div
                className={clsx(
                  menuItemBaseStyle,
                  'flex items-center space-x-2',
                  'px-1'
                )}
              >
                {item.icon && <item.icon className={iconStyle} />}
                <span>{item.name}</span>
              </div>
              {item.options.map((option) => (
                <Item
                  item={option}
                  key={option.name}
                  className="pl-12 text-sm"
                />
              ))}
            </>
          ) : (
            <Item item={item} />
          )}
        </Fragment>
      ))}
    </div>
  )
}

export default Menu
